module.exports = __webpack_public_path__ + "static/1stYear-61975597f463aba2491ff1342583f38d.png";